<footer class="footer">
  <div class="footer-body">
    <div class="left-panel"></div>
    <div class="right-panel">
      @if (title && website) {
        &copy; <span class="mobile-hide">Copyright </span>{{ year }}
        &centerdot; <a [href]="website" target="_blank">{{ title }}</a>
        &centerdot; All rights reserved
      }
      @if (version) {
        &centerdot; {{ version }}
      }
      @if (isIronBackupViewer) {
        @if (viewerLoginUrl) {
          &centerdot; <a [href]="viewerLoginUrl + '/legal-notice'" target="_blank" rel="noopener">{{ 'legal.notice'|translate }}</a>
          &centerdot; <a [href]="viewerLoginUrl + '/privacy'" target="_blank" rel="noopener">{{ 'legal.privacy'|translate }}</a>
        }
      } @else {
        &centerdot; <a [routerLink]="legalOverviewPath">{{ 'legal.overview'|translate }}</a>
        &centerdot; <a [routerLink]="legalNoticePath">{{ 'legal.notice'|translate }}</a>
      }
      &centerdot; <a [href]="licensesUrl" target="_blank" rel="noopener">{{ 'legal.open.source.licenses'|translate }}</a>
    </div>
  </div>
</footer>
